import {
  Box,
  ButtonNew,
  ColorOptions,
  convertHexToRGBA,
  Icon,
  Image,
  Spacer,
  Text,
  useWindowDimensions,
} from '@jfs/ui-new'
import { useNavigation } from '@react-navigation/core'
import { FlatList } from 'react-native'
import { LinearGradientContainer } from '../../comps/LinearGradient'
import { jiobizzPayments } from '../../static/staticData'
import { colors } from '../../util/colors'
import usePadding from '../../util/usePadding'
import { isMobileWidth } from '../../util/util'

export const JioBizz = () => {
  const resPadding = usePadding()
  const { navigate } = useNavigation()

  const viewportWidth = useWindowDimensions()
  const isMob = isMobileWidth(viewportWidth)

  const renderPayments = ({ item }: any) => {
    return (
      <Box
        flexDirection={'row'}
        f={isMob ? undefined : 1}
        pv={isMob ? 8 : 16}
        pr={16}
        align={isMob ? 'center' : undefined}>
        <Box
          w={isMob ? 32 : 42}
          h={isMob ? 32 : 42}
          borderRadius={isMob ? 16 : 21}
          bg={convertHexToRGBA('#ffffff', 20) as ColorOptions}
          align={'center'}
          justify={'center'}>
          <Icon id={item.icon} color={'WHITE'} size={isMob ? 16 : 16} />
        </Box>
        <Spacer direction={'horizontal'} size={isMob ? 12 : 16} />
        <Box pt={isMob ? undefined : 10} f={1}>
          <Text
            title={item.title}
            fontSize={isMob ? 12 : 20}
            letterSpacing={isMob ? -0.24 : -0.4}
            color={'WHITE'}
            lineHeight={isMob ? 18 : 24}
            fontFamily={'jiotype-medium'}
          />
        </Box>
      </Box>
    )
  }
  return (
    <Box ph={resPadding}>
      <LinearGradientContainer
        colorArray={['#000092', '#1634A0']}
        useAngle
        angle={301}
        customStyle={{ borderRadius: 24 }}>
        <Box ph={isMob ? 24 : 64} pv={isMob ? 80 : 84} flexDirection={isMob ? 'column' : 'row'}>
          <Box flexDirection={'column'} f={isMob ? undefined : 0.5}>
            <Text
              title={'JioPay for Business'}
              fontSize={isMob ? 24 : 64}
              fontFamily={'jiotype-black'}
              color={'WHITE'}
              letterSpacing={isMob ? 0 : -2.56}
              textAlign={isMob ? 'center' : undefined}
              lineHeight={isMob ? 36 : 80}
            />
            <Spacer size={isMob ? 16 : 24} />
            <Box maxWidth={isMob ? undefined : '90%'}>
              <Text
                title={'Accept payments for your business easily with JioPay'}
                fontSize={isMob ? 14 : 24}
                fontFamily={isMob ? 'jiotype-medium' : 'jiotype-light'}
                color={'WHITE'}
                letterSpacing={isMob ? 0 : -0.48}
                lineHeight={isMob ? 20 : 40}
                textAlign={isMob ? 'center' : undefined}
                opacity={isMob ? 0.7 : 1}
              />
            </Box>
            <Spacer size={32} />
            {isMob && (
              <Image
                source={require('../../assets/images/jiobizz/footer-bizz.png')}
                width={'100%'}
                height={isMob ? 236 : 400}
                resizeMode={'contain'}
              />
            )}
            <Box maxWidth={isMob ? '100%' : '90%'}>
              <FlatList
                data={[...jiobizzPayments]}
                renderItem={renderPayments}
                numColumns={isMob ? 1 : 2}
                key={isMob ? 'm' : 'd'}
                scrollEnabled={false}
                showsVerticalScrollIndicator={false}
              />
            </Box>
            <Spacer size={isMob ? 32 : 48} />
            <ButtonNew
              title={'Know More'}
              onPress={() => navigate('jiopay')}
              color={'WHITE'}
              textType={isMob ? 'body12' : 'body14'}
              titleColor={colors.JIO_PRIMARY_ALPHA as ColorOptions}
              width={isMob ? 108 : 148}
              height={isMob ? 32 : 48}
              borderRadius={24}
            />
          </Box>
          {!isMob && (
            <Box f={0.5}>
              <Image
                source={require('../../assets/images/jiobizz/footer-bizz.png')}
                width={'100%'}
                height={400}
                resizeMode={'contain'}
              />
            </Box>
          )}
        </Box>
      </LinearGradientContainer>
    </Box>
  )
}
